<template>
  <card>
    <div class="profile-settings__card">
      <h4 class="profile-settings__title">Password</h4>
      <button
        class="button button_blue profile-settings__button btn-change-password"
        @click="showChangePassword"
      >
        Change password
      </button>
    </div>
  </card>
</template>

<script>
import Card from "@/components/card";
import { POPUP_CHANGE_PASSWORD } from "@/constants";
import { saveLog } from '@/modules/logger';

export default {
  components: { Card },

  inject: {
    showModal: { default: () => {} },
  },

  methods: {
    showChangePassword() {
      saveLog("change-password-selected");
      this.showModal(POPUP_CHANGE_PASSWORD);
    },
  },
};
</script>
